import { render, staticRenderFns } from "./ListConfirmationToAndNotAccepted.vue?vue&type=template&id=88ff0344&scoped=true&"
import script from "./ListConfirmationToAndNotAccepted.vue?vue&type=script&lang=js&"
export * from "./ListConfirmationToAndNotAccepted.vue?vue&type=script&lang=js&"
import style0 from "./ListConfirmationToAndNotAccepted.vue?vue&type=style&index=0&id=88ff0344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ff0344",
  null
  
)

export default component.exports